(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("VConsole", [], factory);
	else if(typeof exports === 'object')
		exports["VConsole"] = factory();
	else
		root["VConsole"] = factory();
})(this || self, function() {
return 